import React, { useState } from "react";

import Input from "../../components/Input/Input";
import FetchService from "../../api/FetchService";
import { useLocation } from "react-router-dom";
import "./EditPartner.scss";
import LoadingOverlay from "react-loading-overlay";
import DialogueBox from "../../components/DialogueBox/DialogueBox";

//userTypeID = 1 because its for customers
//Todo: edit this object model
let partnerRequest = {
  id: 0,
    firstname: "",
    lastname: "",
    address: "",
    email: "",
    phone: "",
};

function EditPartner2() {
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  
  const location = useLocation();
    const partner = location.state;

    


    const [firstname, setFirstName] = useState(partner.firstname);
    const [lastname, setLastName] = useState(partner.lastname);
    const [address, setAddress] = useState(partner.address);
    const [email, setEmail] = useState(partner.email);
    const [phone, setPhone] = useState(partner.phone);


    // Invoice-related fields
    const [companyName, setcompanyName] = useState(partner.invoiceDetails?.companyName || '');
    const [organizationNumber, setorganizationNumber] = useState(partner.invoiceDetails?.organizationNumber || '');
    const [invoiceAddress, setinvoiceAddress] = useState(partner.invoiceDetails?.invoiceAddress || '');
    const [invoiceSentTo, setinvoiceSentTo] = useState(partner.invoiceDetails?.invoiceSentTo || '');
    const [contactPerson, setcontactPerson] = useState(partner.invoiceDetails?.contactPerson || '');
    const [invoiceNote, setinvoiceNote] = useState(partner.invoiceDetails?.invoiceNote || '');


    const [showInvoice, setshowInvoice] = useState(!!partner.invoiceDetails);

  const [response, setResponse] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
      partnerRequest = partner;
      partnerRequest.firstname = firstname;
      partnerRequest.lastname = lastname;
      partnerRequest.address = address;
      partnerRequest.phone = phone;
      partnerRequest.partnerSince = new Date().toJSON().slice(0, 10).replace(/-/g, "/");

      if (partnerRequest.invoiceDetails || showInvoice) 
      {
          partnerRequest.invoiceDetails = partnerRequest.invoiceDetails || {};

          if (showInvoice) {
              partnerRequest.invoiceDetails.companyName = companyName;
              partnerRequest.invoiceDetails.organizationNumber = organizationNumber;
              partnerRequest.invoiceDetails.invoiceAddress = invoiceAddress;
              partnerRequest.invoiceDetails.invoiceSentTo = invoiceSentTo;
              partnerRequest.invoiceDetails.contactPerson = contactPerson;
              partnerRequest.invoiceDetails.invoiceNote = invoiceNote;
          }
          else {
              partnerRequest.invoiceDetails.companyName = null;
              partnerRequest.invoiceDetails.organizationNumber = null;
              partnerRequest.invoiceDetails.invoiceAddress = null;
              partnerRequest.invoiceDetails.invoiceSentTo = null;
              partnerRequest.invoiceDetails.contactPerson = null;
              partnerRequest.invoiceDetails.invoiceNote = null;
          }

          partnerRequest.invoiceDetails.invoiceID = partner.invoiceDetails.invoiceID;
      }



    FetchService.UpdateCompany(partnerRequest).then((response) => {
      if (response) {
        setResponse("Success");
        clearForm();
      } else {
        setResponse("Failed");
      }
    });
  };
  const DeletePartner = () => {
    setIsLoading(true);

      FetchService.DeleteCompany(partner.id, partnerRequest.invoiceDetails?.invoiceID ?? null).then((response) => {
      if (response) {
        setTimeout(() => {
          setResponse("Success");
          clearForm();
          setIsLoading(false);
        }, 500);
      } else {
        setTimeout(() => {
          setResponse("Failed");
          setIsLoading(false);
        }, 500);
      }
    });
  };


    // Function to clear form
    function clearForm() {
        setFirstName("");
        setLastName("");
        setAddress("");
        setPhone("");
        setEmail("");
        setcompanyName("");
        setorganizationNumber("");
        setinvoiceAddress("");
        setinvoiceSentTo("");
        setcontactPerson("");
        setinvoiceNote("");
        setshowInvoice(false);
        setIsLoading(false);
    }

    // Function to check if all required fields are filled
    function isFormValid() {
        const personalFieldsFilled = [firstname, lastname, address, phone, email].every(field => field?.trim() !== "");
        const isFakturaValid = !showInvoice ||
            [companyName, organizationNumber, invoiceAddress, invoiceSentTo, contactPerson, invoiceNote]
                .every(field => field && field?.trim() !== "");

        return personalFieldsFilled && isFakturaValid;
    }


  return (
    <LoadingOverlay
      active={isLoading}
      spinner
      text="Behandler forespørselen din"
    >
          <div className="Register_page data-grid">
        <section className="">
          {showConfirmDelete && (
            <DialogueBox
              title={"Bekreft sletting"}
              onConfirm={DeletePartner}
              onConfirmState={null}
              confirmText={"Slette"}
              cancelText={"Avbryt"}
              open={showConfirmDelete}
              setOpen={setShowConfirmDelete}
              stayOnPage={true}
            >
              Er du sikker på at du vil slette denne bedriftskunden?{" "}
            </DialogueBox>
          )}
          <div className="container">
            <div className="row w-100">
              <div className="px-2 ">
                <div className="">
                                  <h2 class="form_heading inner_header_main">Rediger Bedriftskunder</h2>
                  {response === "Failed" && (
                    <div className="error_message">
                      {
                        "Feil: Kunne ikke oppdatere bedriftskunder. Vær så snill, prøv på nytt"
                      }
                    </div>
                  )}
                  {response === "Success" && (
                    <div className="success_message">
                      {"Bedriftskunder er oppdatert"}
                    </div>
                                  )}


                                  <form onSubmit={handleSubmit} className="form_main">
                                      <div className="Input_otr">
                                          <Input
                                              InputClass="Theme_input_white form_input"
                                              Inputype="text"
                                              InputName="First name"
                                              label="Fornavn"
                                              value={firstname}
                                              required={false}


                                              onChange={(event) => setFirstName(event.target.value)}
                                          />
                                      </div>
                                      <div className="Input_otr">
                                          <Input
                                              InputClass="Theme_input_white form_input"
                                              Inputype="text"
                                              InputName="Last name"
                                              label="Etternavn"
                                              value={lastname}
                                              required={false}

                                              onChange={(event) => setLastName(event.target.value)}
                                          />
                                      </div>

                                      <div className="Input_otr">
                                          <Input
                                              InputClass="Theme_input_white form_input"
                                              Inputype="text"
                                              InputName="address"
                                              label="Adresse"
                                              value={address}
                                              required={false}

                                              onChange={(event) => setAddress(event.target.value)}
                                          />
                                      </div>


                                      <div className="Input_otr">
                                          <Input
                                              InputClass="Theme_input_white form_input"
                                              label="Email"
                                              value={email}
                                              required={false}

                                              onChange={(event) => setEmail(event.target.value)}
                                          />
                                      </div>

                            


                                      <div className="Input_otr">
                                          <Input
                                              InputClass="Theme_input_white form_input"
                                              Inputype="number"
                                              InputName="phone"
                                              label="Telefonnummer"
                                              value={phone}
                                              required={false}

                                              onChange={(event) => setPhone(event.target.value)}
                                          />
                                      </div>



                                      <div>
                                          <label>Ønsker du å legge til fakturainformasjon?</label>
                                          <div>
                                          
                                              <label class="padding-18" htmlFor="fakturaJa">    <input
                                                  type="radio"
                                                  id="fakturaJa"
                                                  name="faktura"
                                                  checked={showInvoice === true}
                                                  value="true" // Ensure it's a string
                                                  onChange={() => setshowInvoice(true)}
                                              /> Ja</label>
                                           
                                              <label class="padding-18" htmlFor="fakturaNei">   <input
                                                  type="radio"
                                                  id="fakturaNei"
                                                  name="faktura"
                                                  value="false" // Ensure it's a string
                                                  checked={showInvoice === false}
                                                  onChange={() => setshowInvoice(false)}
                                              /> Nei</label>
                                          </div>

                                      </div>


                                      {showInvoice && (
                                          <div className="invoice-section">
                                              <h4 className="mx-4 text-center fw-bold m-2" >FAKTURA INFORMASJON</h4>
                                              <div className="form-group">
                                                  <div class="row  d-flex justify-content-center align-items-end" >
                                                      <div class=" my-3 col-md-6">
                                                          <div >

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="label_input heading-xs required">Bedriftsnavn:</h6>
                                                                  <input
                                                                      tabindex="2"
                                                                      required
                                                                      type="text"
                                                                      name="companyName"
                                                                      value={companyName}
                                                                      onChange={(event) => setcompanyName(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="label_input heading-xs required">Org nr:</h6>
                                                                  <input
                                                                      tabindex="4"
                                                                      required
                                                                      type="text"
                                                                      name="organizationNumber"
                                                                      value={organizationNumber}
                                                                      onChange={(event) => setorganizationNumber(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="label_input heading-xs">Faktura adresse:</h6>
                                                                  <input
                                                                      tabindex="6"
                                                                      required
                                                                      type="text"
                                                                      name="invoiceAddress"
                                                                      value={invoiceAddress}
                                                                      onChange={(event) => setinvoiceAddress(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>
                                                          </div>
                                                      </div>

                                                      <div class="label_input heading-xs my-3 col-md-6">
                                                          <div >

                                                              <div class="input-container Input_otr">
                                                                  <h6 class=" required">Faktura sendes til:</h6>
                                                                  <input
                                                                      required
                                                                      tabindex="3"
                                                                      type="text"
                                                                      name="invoiceSentTo"
                                                                      value={invoiceSentTo}
                                                                      onChange={(event) => setinvoiceSentTo(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="label_input heading-xs">contactPerson:</h6>
                                                                  <input
                                                                      required
                                                                      tabindex="5"
                                                                      type="text"
                                                                      name="contactPerson"
                                                                      value={contactPerson}
                                                                      onChange={(event) => setcontactPerson(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                  />
                                                              </div>

                                                              <div class="input-container Input_otr">
                                                                  <h6 class="label_input heading-xs">Faktura merkes med:</h6>
                                                                  <input
                                                                      required
                                                                      tabindex="7"
                                                                      type="text"
                                                                      name="invoiceNote"
                                                                      value={invoiceNote}
                                                                      onChange={(event) => setinvoiceNote(event.target.value)}
                                                                      className="Theme_input_white form_input"
                                                                      rows="4"
                                                                  />
                                                              </div>

                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>

                                          </div>
                                      )}



                                      <div className="Input_otr action_otr">
                                          <button
                                              disabled={!isFormValid()}
                                              type="submit"
                                              className="Theme_btn_primary form_btn"
                                          >
                                              Legg til
                                          </button>
                                      </div>


                                      <div className="Input_otr action_otr">
                                              <button
                                                type="button"
                                                onClick={() => setShowConfirmDelete(true)}
                                                className="Theme_btn_primary form_btn bg-danger"
                                              >
                                              Slette Bedriftskunder
                                          </button>
                                    </div>

                                  </form>

                  
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </LoadingOverlay>
  );
}

export default EditPartner2;
